var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-christmas",
            "modal-class": "custom-modal",
            "content-class": "popup",
            "hide-header": "",
            "hide-footer": ""
          },
          on: {
            show: function($event) {
              return _vm.toggleParentScroll(false)
            },
            hidden: function($event) {
              return _vm.toggleParentScroll(true)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "christmas-popup",
              class: { "christmas-popup-ama": _vm.isAma }
            },
            [
              !_vm.isAma
                ? _c("img", {
                    staticClass: "ribbon",
                    attrs: {
                      src: _vm.baseImageUrl + "/popup/christmas/ribbon.png"
                    }
                  })
                : _vm._e(),
              _c("div", { staticClass: "background" }),
              _c("div", { staticClass: "header" }, [
                _c(
                  "span",
                  {
                    staticClass: "close-btn",
                    on: {
                      click: function($event) {
                        return _vm.closeModal()
                      }
                    }
                  },
                  [
                    _c("font-awesome-icon", {
                      attrs: { icon: ["fa", "times"] }
                    })
                  ],
                  1
                ),
                !_vm.isAma
                  ? _c("img", {
                      staticClass: "logo",
                      attrs: { src: _vm.getLogoUrl() }
                    })
                  : _vm._e()
              ]),
              _c("h3", { staticClass: "title" }, [
                _c("span", { staticClass: "first" }, [_vm._v("Merry")]),
                _c("span", { staticClass: "second" }, [_vm._v("Christmas")])
              ]),
              _c("p", { staticClass: "subtitle" }, [
                _vm._v(_vm._s(_vm.$t("popup.christmas.subtitle")))
              ]),
              !_vm.isAma
                ? _c(
                    "button",
                    {
                      staticClass: "btn shop-btn",
                      on: {
                        click: function($event) {
                          return _vm.goToShop()
                        }
                      }
                    },
                    [_vm._v("SHOP")]
                  )
                : _vm._e()
            ]
          )
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-new-year",
            "modal-class": "custom-modal",
            "content-class": "popup",
            "hide-header": "",
            "hide-footer": ""
          },
          on: {
            show: function($event) {
              return _vm.toggleParentScroll(false)
            },
            hidden: function($event) {
              return _vm.toggleParentScroll(true)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "new-year-popup",
              class: { "new-year-popup-ama": _vm.isAma }
            },
            [
              _c("div", { staticClass: "background" }),
              _c("div", { staticClass: "header" }, [
                _c(
                  "span",
                  {
                    staticClass: "close-btn",
                    on: {
                      click: function($event) {
                        return _vm.closeModal()
                      }
                    }
                  },
                  [
                    _c("font-awesome-icon", {
                      attrs: { icon: ["fa", "times"] }
                    })
                  ],
                  1
                ),
                !_vm.isAma
                  ? _c("img", {
                      staticClass: "logo",
                      attrs: { src: _vm.getLogoUrl() }
                    })
                  : _vm._e()
              ]),
              _c("h3", { staticClass: "title" }, [
                _c("span", { staticClass: "first" }, [_vm._v("Happy")]),
                _c("span", { staticClass: "second" }, [_vm._v("New Year")])
              ]),
              _c("p", { staticClass: "subtitle" }, [
                _vm._v(_vm._s(_vm.$t("popup.new_year.subtitle")))
              ]),
              _c("div", { staticClass: "text-center" }, [
                !_vm.isAma
                  ? _c(
                      "button",
                      {
                        staticClass: "btn shop-btn",
                        on: {
                          click: function($event) {
                            return _vm.goToShop()
                          }
                        }
                      },
                      [_vm._v("SHOP")]
                    )
                  : _vm._e()
              ])
            ]
          )
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-vicenzaoro",
            "modal-class": "custom-modal",
            "content-class": "popup",
            "hide-header": "",
            "hide-footer": "",
            "no-close-on-backdrop": ""
          },
          on: {
            show: function($event) {
              return _vm.toggleParentScroll(false)
            },
            hidden: function($event) {
              return _vm.toggleParentScroll(true)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "vicenzaoro-popup",
              class: { "vicenzaoro-popup-ama": _vm.isAma }
            },
            [
              _c(
                "a",
                {
                  attrs: {
                    target: "_blank",
                    href:
                      "https://calendly.com/gioielleriaitaliana_marketing/vicenzaoro-gennaio-2024"
                  }
                },
                [
                  _c("div", { staticClass: "background" }),
                  _c("div", { staticClass: "header" }, [
                    _c(
                      "span",
                      {
                        staticClass: "close-btn",
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.closeModal()
                          }
                        }
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: ["fa", "times"] }
                        })
                      ],
                      1
                    ),
                    !_vm.isAma
                      ? _c("img", {
                          staticClass: "logo d-md-none",
                          attrs: { src: _vm.getLogoUrl() }
                        })
                      : _vm._e()
                  ]),
                  _c("div", { staticClass: "row text" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-12 first-col",
                        class: { "col-md-6": !_vm.isAma }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("popup.vicenzaoro.subtitle1")) + " "
                          ),
                          _c("b", [_vm._v("Pad. 6, Stand 254")])
                        ])
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-12 second-col",
                        class: { "col-md-6": !_vm.isAma }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("popup.vicenzaoro.subtitle2")))
                        ])
                      ]
                    ),
                    _c("div", { staticClass: "col-12 book-here text-yellow" }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("popup.vicenzaoro.book_here")) + " "
                      ),
                      _vm.isAma
                        ? _c("img", {
                            staticClass: "click-icon",
                            attrs: {
                              src:
                                "https://content.gioielleriaitaliana.com/cr/popup/icons/click_AMA.png"
                            }
                          })
                        : _vm._e(),
                      !_vm.isAma
                        ? _c("img", {
                            staticClass: "click-icon",
                            attrs: {
                              src:
                                "https://content.gioielleriaitaliana.com/cr/popup/icons/click_GI.png"
                            }
                          })
                        : _vm._e()
                    ])
                  ])
                ]
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }